<template>
  <div class="elements" :class="{ horizontal, timeRelation }">
    <div class="hidden-info" v-if="hiddenCount">{{ hiddenCount }} element(s) hidden</div>
    <template v-for="elem in visibleElems">
      <div class="anchor" :key="elem._id + 'anchor'">
        <div
          class="drop-zone"
          :class="{ horizontal }"
          @click="insertBefore(elem)"
          @contextmenu.prevent="(e) => rightClick(e, elem)"
        />
      </div>
      <component :is="compType" :parent="parent" :itemID="elem._id" :key="elem._id" />
    </template>
    <div class="anchor">
      <div class="drop-zone" :class="{ horizontal }" @click="append" />
    </div>
  </div>
</template>

<style scoped>
.elements {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.elements.horizontal {
  flex-direction: row;
}

.hidden-info {
  font-size: var(--text-size-secondary);
  opacity: var(--text-opacity-secondary);
  text-align: left;
  padding: 0 10px;
  font-style: italic;
}
.anchor {
  position: relative;
}
.drop-zone {
  position: absolute;
  cursor: pointer;
  z-index: 8;
}

.selectionMode .drop-zone {
  width: 100%;
  height: 32px;
  transform: translate(0, -50%);
}
.selectionMode .drop-zone.horizontal {
  width: 32px;
  height: 100%;
  transform: translate(-50%, 0);
}
.selectionMode .drop-zone:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>

<script>
import { REL_PLAN } from "@/structure";
import selection from "../selection";

export default {
  name: "SortableList",
  props: ["parent", "elements", "compType", "horizontal"],
  components: {
    // Async import to solve circular dependency and make recursion work. See
    // https://v2.vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
    card: () => import("./ItemCard.vue"),
    list: () => import("./ItemList.vue"),
  },
  computed: {
    elemCount() {
      return this.elements.length;
    },
    hiddenCount() {
      return this.elemCount - this.visibleElems.length;
    },
    visibleElems() {
      return this.elements.filter((el) => el.isVisible());
    },
    timeRelation() {
      return this.parent.childRel === REL_PLAN;
    },
  },
  methods: {
    insertBefore(elem) {
      selection.insertBefore(elem, this.parent);
    },
    append() {
      selection.appendTo(this.parent);
    },
    rightClick(event, elem) {
      if (this.horizontal) {
        event.stopPropagation();
        return;
      }
      const index = this.visibleElems.findIndex((el) => el._id === elem._id);
      var clickArea = event.target.getBoundingClientRect();
      var clickPart = (event.clientY - clickArea.top) / clickArea.height;
      let childIdx = -1;
      if (clickPart < 0.4) {
        childIdx = index - 1;
      } else if (clickPart > 0.6) {
        childIdx = index;
      }
      if (0 <= childIdx && childIdx < this.visibleElems.length) {
        selection.toggle(this.visibleElems[childIdx]);
      }
    },
  },
};
</script>
